

import { useState } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'



/* Hooks */
import useFlashMessage from '../../../../hooks/useFlashMessage'

/* form */
import FormBudgetItem from './Form/FormBudgetItem'
import RandomString from '../../../../shared/functions/RandomString'

function EditBudgetItem({ btCancelAction, handleOnSuccess, handleOnEditItem, clientId, item, permission }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()


    console.log("item")
    console.log(item)

    function EditBudgetItem(budgetItem) {



        handleOnEditItem(budgetItem)

    }

    return (
        item && (
            <FormBudgetItem title="Editar Item" clientId={clientId} handleSubmit={EditBudgetItem} btCancelAction={btCancelAction} btnText="Concluir" btnVariant="finish" handleOnSuccess={handleOnSuccess}
            itemData={item} additionalSizeData={item.additionalSize} sizesData={item.sizes}
            additiveArrayData={item.additive} accessoryArrayData={item.accessoriesSelected}
            imgClientArrayData={item.clientImgsSelected}
            commissionData={item.commissionValue}
            discountData={item.discountValue}
            colorsData={item.colors}
            printsData={item.prints}
            embroideryData={item.embroidery}
            permission={permission}
            />
        )
    )
}

export default EditBudgetItem